<template>
  <div class="custom_project_select">
    <multiselect
      name="projects"
      v-model="selectedProjects"
      :options="projects"
      @input="updateSelected"
      placeholder="Все проекты"
      track-by="name"
      label="name"
      :showLabels="false"
      :searchable="false"
      :multiple="true">
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  data () {
    return {
      selectedProjects: null,
      projects: []
    }
  },
  computed: {
    $AllProjects () {
      const projects = this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = { ...p }
          return acc
        },
        {}
      )
      return projects
    },
  },
  mounted () {
    this.projects = _.orderBy(Object.values(this.$AllProjects), 'title')
  },
  methods: {
    updateSelected () {}
  }
}
</script>

<style>
.custom_project_select .multiselect__tags {
  height: 38px;
}
</style>
